import { useEffect, useState } from "react";
import "./UserAccountTransfers.scss";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import RegistrationSelect from "../../UI/Registration/RegistrationSelect";
import RegistrationInput from "../../UI/Registration/RegistrationInput";
import { getErrorMessage2 } from "../../../util/utilfunctions/utilFunctions";
import Contacts from "./Contacts";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { riaCancelReasons, riaTrackTransaction, createRiaDraftOrder, getRiaPayoutPartnerLocations, getRiaPayoutPartners, getRiaReferneceData, getRiaStates, riaCreateContact, riaReceiveMoney, riaSearchCashPickupOrder, riaSendMoney, riaGetDeliveryMethods, getRiaOrderRequirements, riaGetMobileWallets, getRiaIDTypes, getRiaBanks, riaCancelTransaction, riaIntegrationGetTransferReasons } from "../../../util/API/ria";
import InternationalTransferHistory from "./InternationalTransfers/InternationalTransferHistory";
import InternationalTransferFooterButtons from "./InternationalTransfers/InternationalTransferFooterButtons";
import InternationalTransferSummary from "./InternationalTransfers/InternationalTransferSummary";
import PinPad from "../../PinPad/PinPad";
import InternationalTransferTrack from "./InternationalTransfers/InternationalTransferTrack";

function RIA({handleBack}) {
    const [page, setPage] = useState("wait");
    const [contacts, setContacts] = useState(null);
    const [history, setHistory] = useState(null);
    const [formValues, setFormValues] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const selectedUser = useSelector((state) => state.usersList.selectedUser);
    const [selectedContact, setSelectedContact] = useState(null);
    const [contactButtonText, setContactButtonText] = useState("Save contact");
    const [alert, setAlert] = useState({});
    const [showPin, setShowPin] = useState(false);
    const [orderStatus, setOrderStatus] = useState('');
    const [requiredFields, setRequiredFields] = useState({
        BeneAddress: false,
        BeneZipCode: false,
        BeneIDType: false,
        BeneIDNo: false,
        BeneCity: false,
        BenePhoneNo: false,
        UnitaryBankAccountNo: false,
        BankAccountNo: false,
        BankBranchName: false,
        BankRoutingCode: false,
        BankBranchCity: false,
        BankBranchNo: false,
        payoutpartnerlocation: false,
        BeneEmail: false,
        MobileWalletAccountNo: false
    });
    const [refundDetails, setRefundDetails] = useState({});
    const [cancelReasons, setCancelReasons] = useState([]);
    const [cancelFormValues, setCancelFormValues] = useState({});

    const [selectedPartner, setSelectedPartner] = useState(null);
    const [selectedCurrencies, setSelectedCurrencies] = useState([]);

    const [riaOptions, setRiaOptions] = useState({});
    const selectedUserID = selectedUser.User.id;
    let agent = sessionStorage.getItem("user");
    agent = JSON.parse(agent);
    agent = agent.payload.body.User;

    const parentuserid = sessionStorage.getItem("parentuserid");
    const isOperator = sessionStorage.getItem("isOperator");

    let isAutoRetry;


    useEffect(() => {
        getProfile();
    }, []);

    async function getProfile() {
        let response = await getRiaReferneceData(selectedUserID);
        const payload = response.payload;
        console.log("getRiaReferneceData=========",payload);
        let countries = payload.GetCountry.payload.countries;
        const mappedCountries = countries.map(({ code, name }) => ({ key: code, value: code, label: name }));

        let industryCategoires = payload?.IndustryCategory?.payload?.industryCategories;
        if (!Array.isArray(industryCategoires)) {
            industryCategoires = [industryCategoires];
        }
        const mappedIndustries = industryCategoires.map(({ id, name }) => ({ key: id, value: id, label: name }));

        let occupations = payload.Occupation.payload.occupations;
        if (!Array.isArray(occupations)) {
            occupations = [occupations];
        }
        const mappedOccupations = occupations.map(({ id, name }) => ({ key: id, value: id, label: name }));

        let history = payload.History.payload.record;
        if (!Array.isArray(history)) {
            history = [history];
        }
        setHistory(history);

        let contacts = payload.ContactList.payload.record;
        if (!Array.isArray(contacts)) {
            contacts = [contacts];
        }
        contacts = contacts.filter(function (contact) {
            let otherdata;
            try {
                otherdata = JSON.parse(contact.Usercontactlistexternal.other.replaceAll(/&(amp;)*quot;/g, '"'));
            } catch (err) {

            }
            if (otherdata?.type === "RIA") return true;
        })
        setContacts(contacts);
        setContactButtonText("Save Contact");

        setRiaOptions({
            countries: mappedCountries,
            industryCategoires: mappedIndustries,
            occupations: mappedOccupations
        })
        getLandingScreenData();
        editFormValues('userid', selectedUserID);
    }

    // useEffect(()=> {
    //     console.log("formValues=============", formValues);
    // },[formValues])

    useEffect(() => {
        if (page === 'landing') {
            setSelectedContact(null);
            getLandingScreenData();
            setFormErrors({});
            setFormValues((prev) => ({
                ...prev,
                'agentid': agent.id,
                'agentName': agent.firstName + " " + agent.lastName,
                'clerkname': agent.firstName + " " + agent.lastName,
                'agentCountry': agent.countryid,
                'ramount': '',
                userid: selectedUserID
            }));
        } else if (page === 'getTransaction') {
            getSummaryDetails();
        } else if (page === 'getReceiveTransaction') {
            getReceiveSummary()
        } else if (page === 'sendTransaction') {
            setShowPin(true);
        } else if (page === 'receiveTransaction') {
            setShowPin(true);
        } else if (page === 'send') {
            setFormValues((prev) => ({
                ...prev,
                'agentid': agent.id,
                'agentName': agent.firstName + " " + agent.lastName,
                'clerkname': agent.firstName + " " + agent.lastName,
                'agentCountry': agent.countryid,
                transferType: 'send'
            }));
        } else if (page === 'receive') {
            setFormValues((prev) => ({
                ...prev,
                'agentid': agent.id,
                'agentName': agent.firstName + " " + agent.lastName,
                'clerkname': agent.firstName + " " + agent.lastName,
                'agentCountry': agent.countryid,
                transferType: 'receive'
            }));
        } else if (page === 'deliveryMethod') {
            if (formValues.deliverymethodid == 1 || formValues.deliverymethodid == 3) {
                getPartners();
                setPage("cashpickup");
            } else if (formValues.deliverymethodid == 2) {
                getBanks();
                setPage('bank');
            } else if (formValues.deliverymethodid == 34) {
                getMobileWallets();
                setPage('mobile');
            }

        } else if (page === 'reload') {
            getProfile();
            setPage("wait");
        } else if (page === 'getRequirements') {
            getOrderRequirements();
        }
    }, [page]);

    const handlePinConfirm = (event, pin) => {
        const userPin = pin.join('');
        setFormValues((prev) => ({
            ...prev,
            PIN: userPin
        }));
        if (formValues.transferType === 'send') {
            sendMoney(userPin);
        } else if (formValues.transferType === 'cancel') {
            confirmCancel(userPin);
        } else {
            receiveMoney(userPin)
        }
    }

    const getPartners = async () => {
        let response = await getRiaPayoutPartners(formValues);
        if (response.Status !== '1') {
            return;
        }
        let payoutPartners = response.payload.payoutPartners;
        if (!Array.isArray(payoutPartners)) {
            payoutPartners = [payoutPartners];
        }
        const mappedPartners = payoutPartners.map((payout) => {
            let product111 = payout.products;
            if (!Array.isArray(product111)) {
                product111 = [product111];
            }
            product111 = product111.find(product => product.id === "111");
            let productCurrencies = product111?.currencies || [];
            if (!Array.isArray(productCurrencies)) {
                productCurrencies = [productCurrencies];
            }
            const currencies = productCurrencies.map(currency => ({
                key: currency.code,
                label: currency.code,
                value: currency.code
            }));
            const locationRequired = payout.networkModel?.requiredFields.includes("PayoutLocationId");
            return {
                key: payout.id,
                value: payout.id,
                label: payout.name,
                currencies,
                locationRequired: locationRequired
            };
        });
        setRiaOptions((prev) => ({
            ...prev,
            payoutPartners: mappedPartners
        }));
    }

    const handlePartnerChange = (selectedId) => {
        const partner = riaOptions.payoutPartners.find(p => p.key === selectedId);
        setRequiredFields((prev) => ({
            ...prev,
            payoutpartnerlocation: partner.locationRequired
        }));
        
        if (partner) {
            setSelectedPartner(partner);
            setSelectedCurrencies(partner.currencies);
        } else {
            setSelectedPartner(null);
            setSelectedCurrencies([]);
        }
    };

    const handleBankChange = (selectedId) => {
        const bank = riaOptions.banks.find(p => p.key === selectedId);
        setSelectedCurrencies(bank.currencies);
    }

    const getPartnerLocations = async () => {
        let response = await getRiaPayoutPartnerLocations(formValues);
        if (response.Status !== '1') {
            return;
        }
        let partnerLocations = response.payload.payoutPartnerLocations;
        if (!Array.isArray(partnerLocations)) {
            partnerLocations = [partnerLocations];
        }
        const mappedPartnerLocations = partnerLocations.map(({ id, address }) => ({ key: id, value: id, label: address.address }));
        setRiaOptions((prev) => ({
            ...prev,
            payoutPartnersLocations: mappedPartnerLocations
        }));
    }
    const getStates = async () => {
        let response = await getRiaStates(formValues);
        if (response.Status !== '1') {
            return;
        }
        let states = response.payload.states;
        if (!Array.isArray(states)) {
            states = [states];
        }
        const mappedStates = states.map(({ code, name }) => ({ key: code, value: code, label: name }));
        setRiaOptions((prev) => ({
            ...prev,
            states: mappedStates
        }));
    }

    useEffect(() => {
        console.log("useEffect===========",formValues);
    }, [formValues])

    useEffect(() => {
        getPartnerLocations()
    }, [formValues.payoutpartnerid])
    useEffect(() => {
        getStates()
    }, [formValues.receivercountrydropdown])

    const getSummaryDetails = async () => {
        setPage('wait');
        console.log("formValues================",formValues);
        let response = await createRiaDraftOrder(formValues);
        console.log("getSummaryDetails_response================",response);
        if (response.Status !== '1') {
            setAlertData(response, true, "", true);
            return;
        }
        let fees = response.fee;
        fees['riafee'] = response.riafee;
        let feeTotal = parseFloat(response.riafee);
        let taxTotal = parseFloat(response.tax.taxamount);
        let feeconsumertotal = parseFloat(fees.feeconsumertotal);
        let amountData = response.amount;
        let beneficiaryAmount = amountData.BenAmt;

        setFormValues((prev) => ({
            ...prev,
            'agentid': agent.id,
            'agentName': agent.firstName + " " + agent.lastName,
            'clerkname': agent.firstName + " " + agent.lastName,
            'agentCountry': agent.countryid,
            'servicefee': feeTotal,
            'taxamount': taxTotal,
            'totalamount': parseFloat(formValues.ramount) + feeTotal + taxTotal + feeconsumertotal,
            'receiveamount': parseFloat(beneficiaryAmount),
            'riafee': feeTotal,
            'feeconsumertotal': feeconsumertotal
        }));
        setPage('summary');
    }

    const getReceiveSummary = async () => {
        setPage('wait');
        let response = await riaSearchCashPickupOrder(formValues.riapin);
        if (response.Status !== "1") {
            setAlertData(response, true, "", true);
            return;
        }
        let payload = response.payload;
        if (payload.ResponseCode === "2002") {
            setAlert({
                showAlert: true,
                severity: "error",
                message: "Order has already been marked as paid to beneficiary.",
                header: "Error"
            });
            setPage('landing');
            return;
        }
        setFormValues((prev) => ({
            ...prev,
            'CustNameFirst': payload.CustNameFirst,
            'CustNameLast1': payload.CustNameLast1,
            'BeneAmount': payload.BeneAmount,
            'BeneAddress': payload.BeneAddress,
            'OrderNo': payload.OrderNo,
            'TransRefID': payload.TransRefID,
            'BeneNameFirst': payload.BeneNameFirst,
            'BeneNameLast1': payload.BeneNameLast1,
            'agentid': agent.id,
            'agentName': agent.firstName + " " + agent.lastName,
            'clerkname': agent.firstName + " " + agent.lastName,
            'agentCountry': agent.countryid,
        }));
        if (payload.BeneNameFirst.toLowerCase() !== selectedUser.User.firstName.toLowerCase() && payload.BeneNameLast1.toLowerCase() !== selectedUser.User.lastName.toLowerCase()) {
            setAlert({
                showAlert: true,
                severity: "error",
                message: "Beneficiary name does not match",
                header: "Error"
            });
            setPage('landing');
            return;
        }
        setPage("receivesummary");
    }

    const getLandingScreenData = async () => {
        setFormValues({
            'agentid': agent.id,
            'agentName': agent.firstName + " " + agent.lastName,
            'clerkname': agent.firstName + " " + agent.lastName,
            'agentCountry': agent.countryid,
            'userid': selectedUserID,
            'ramount': '',
        });
        setPage("landing");
    }

    async function sendMoney(agentPIN) {
        setShowPin(false);
        setPage("wait");
        const riaFormData = { ...formValues, ...selectedUser.User, PIN: agentPIN, parentuserid: parentuserid, isOperator: isOperator }
        let response = await riaSendMoney(riaFormData);
        console.log("Full sendMoney payload:", response.payload); // ← add this
        console.log("sendMoney_response--------------",JSON.stringify(response));
        let callStatus = response.callStatus;
        if (callStatus !== '1') {
            setAlertData(response, true, "", true);
            return;
        }
        let payload = response.payload;
        let orderNum = payload.PCOrderNo;
        let riaPIN = payload.RiaPin;
        let trngrpid = payload.trngrpid;
        setFormValues((prev) => ({
            ...prev,
            'riaPIN': riaPIN,
             'trngrpid': trngrpid 
        }));
        setPage('receipt');
    }
    async function receiveMoney(agentPIN) {
        setShowPin(false);
        setPage("wait");
        const riaFormData = { ...formValues, ...selectedUser.User, PIN: agentPIN, parentuserid: parentuserid, isOperator: isOperator }
        console.log("riaFormData=====",riaFormData);
        let response = await riaReceiveMoney(riaFormData);
        let callStatus = response.payload.callStatus;
        if (callStatus !== '1') {
            setAlertData(response, true, "", true);
            return;
        }
        let customerData = response.payload.forCustomer;
        let emerlinkrefnumber = customerData.emerlinkrefnumber;
        let refid = customerData.refid;
        setFormValues((prev) => ({
            ...prev,
            'emerlinkrefnumber': emerlinkrefnumber,
            'refid': refid,
        }));
        setPage('receiptreceive');
    }

    useEffect(() => {
        if (selectedContact) {
            console.log("selected Contact----------", selectedContact);
            checkContactExists();
            setPage('contact');
        }
    }, [selectedContact])

    const resendTransaction = (item) => {
        const parsedItem = JSON.parse(item);
        console.log("resendTransaction_parsedItem===============", parsedItem);
        let receiverName = parsedItem.receivername.split(" ");
        console.log("resendTransaction===============", formValues);
        let parsedTxData = JSON.parse(parsedItem?.txdata)
        console.log("resendTransaction_parsedTxData===============", parsedTxData);
        setFormValues((prev) => ({
            ...prev,
            'agentid': agent.id,
            'agentName': agent.firstName + " " + agent.lastName,
            'clerkname': agent.firstName + " " + agent.lastName,
            'agentCountry': agent.countryid,
            'amount': '',
            rfirstname: receiverName[0],
            rlastname: receiverName[1],
            transferType: "send",
            ...parsedItem,
            'ramount': '',
            'transferreason': parsedTxData?.transferreason,
            'transferreasonid': parsedTxData?.transferreasonid
        }));
        setPage("shortform");
    }

    const sendToContact = () => {
        let contactOther = JSON.parse(selectedContact.Usercontactlistexternal.other.replaceAll(/&(amp;)*quot;/g, '"'));
        console.log("sendToContact_contactOther============", contactOther);
        let name = selectedContact.Usercontactlistexternal.lastName.split(" ")
        let lastName = '';
        for (let i = 1; i < name.length; i++) {
            lastName += name[i] + " ";
        }
        lastName = lastName.trim();

        setFormValues(prev => {
            const updates = {
                rfirstname: selectedContact.Usercontactlistexternal.firstName,
                rlastname: selectedContact.Usercontactlistexternal.lastName,
                // rfirstname: name[0],
                // rlastname: lastName,
                senderdeliverymethodid: contactOther.pOutID ?? contactOther?.deliverymethodid,
                deliverymethodid: contactOther.pOutID ?? contactOther?.deliverymethodid,
                senderreceiverrelation: contactOther.relationship,
                currencyCode: contactOther.cur ?? contactOther?.currencytoreceive,
                receivercountry: contactOther.nat ?? contactOther.receivercountrycode,
                receivecountry: contactOther.ctry ?? contactOther?.receivercountrycode,
                receivercountrydropdown: contactOther.nat ?? contactOther?.receivercountrycode,
                receiverState: contactOther.receiverstate ?? contactOther?.receiverstate,
                receiverZip: contactOther.zip,
                city: contactOther.city ?? contactOther.receivercity,
                receiverAddress: contactOther.addr,
                receiverEmail: contactOther.email,
                receiverPhone: contactOther.ph,
                payoutpartnerid: contactOther?.payID,
                receiverbankacct: contactOther.bAcct,
                receiverbankroutingcode: contactOther.bRoute,
                receiverbankid: contactOther.bID,
                receiverbankcity: contactOther.bCity,
                receiverbanknumber: contactOther.bNum,
                beneidno: contactOther.beneidno,
                beneidtype: contactOther.beneidtype,
                receivermobilewalletnumber: contactOther.wallet,
                unitarybankaccountno: contactOther.uBank,
                unitarytype: contactOther.uType,
                virtualpaymentaccountno: contactOther.vpAC,
                bankbranchname: contactOther.bName,
                virtualPaymentProviderID: contactOther.vpID,
                transferType: "send",
                'agentid': agent.id,
                'agentName': agent.firstName + " " + agent.lastName,
                'clerkname': agent.firstName + " " + agent.lastName,
                'agentCountry': agent.countryid,
                'transferreason': contactOther?.transferreason,
                'transferreasonid': contactOther?.transferreasonid
            };

            // Remove keys with null or undefined values
            const filteredUpdates = Object.fromEntries(
                Object.entries(updates).filter(([_, v]) => v != null)
            );

            return {
                ...prev,
                ...filteredUpdates
            };
        });
        setPage("shortform");
    }

    const editFormValues = (key, value) => {
        setFormValues((prev) => ({
            ...prev,
            'agentid': agent.id,
            'agentName': agent.firstName + " " + agent.lastName,
            'clerkname': agent.firstName + " " + agent.lastName,
            'agentCountry': agent.countryid,
            [key]: value
        }));
    }

    const checkContactExists = () => {
        for (let contact of contacts) {
            let contactData = contact.Usercontactlistexternal
            if (contactData.firstname === formValues.receiverfirstname && contactData.lastname === formValues.receiverlastname) {
                setFormValues((prev) => ({
                    ...prev,
                    'agentid': agent.id,
                    'agentName': agent.firstName + " " + agent.lastName,
                    'clerkname': agent.firstName + " " + agent.lastName,
                    'agentCountry': agent.countryid,
                    contactExists: true
                }));
                setContactButtonText("Contact Already Saved");
            }
        }
    }

    const saveContact = async () => {
        let response = await riaCreateContact(formValues);
        if (response.Status !== '1') {
            setAlertData(response, true, "", true);
            return;
        }
        setContactButtonText("Contact saved");
    }

    const getContactInformation = () => {
        if (!selectedContact) return;
        const data = selectedContact.Usercontactlistexternal;
        let otherdata = {};
        try {
            otherdata = JSON.parse(data.other.replaceAll(/&(amp;)*quot;/g, '"'));
        } catch (error) {

        }
        return (
            <Box>
                <Box>Name: {data.firstName} {data.lastName}</Box>
                <Box>Address: {otherdata.receiveraddress}, {otherdata.receivercity}, {otherdata.receiverstate}, {otherdata.receivercountrycode}</Box>
                {otherdata.state ? <Box>State: {otherdata.state}</Box> : ''}
            </Box>);
    }

    const validation = {
        deliveryMethod: ["receivecountry", "deliverymethodid", "ramount"],
        recipient: ["payoutpartnerid", "currencyCode"],

    }

    const validateForm = (page) => {
        const errors = {};
        const requiredFields = validation[page] || [];

        requiredFields.forEach((key) => {
            if (!formValues[key]) {
                errors[key] = true;
            }
        });

        setFormErrors(errors);
        if (Object.keys(errors).length !== 0) {
            return;
        }
        console.log("page==========",page);
        setPage(page);
        return Object.keys(errors).length === 0; // Return true if no errors
    };

    const trackTransaction = async(refNumber, data) => {
        data = JSON.parse(data);
        const refid = data.refid;
        const response = await riaTrackTransaction(refid);
        
        if (response.Status !== '1') {
            const msg = response?.payload?.msg
            if (msg === 'order not found'){
                setOrderStatus('UNCOMMITTED');
            }
            setPage("track");
            return;
        }
        const orderno = response?.payload?.body?.number;
        let status = response?.payload?.body?.statusdesc;
        if (!status) {
            status = response?.payload?.body?.status === "10" ? "HOLD" : "ERROR";
        }
        if (status === 'Processing') {
            setOrderStatus('AVAIL');
        } else if (status === 'Canceled'){
            setOrderStatus('CANCL');
        } else if (status === 'Paid') {
            setOrderStatus('RECVD');
        } else if(status === 'Refunded') {
            setOrderStatus('REFND');
        } else {
            setOrderStatus(status);
        }
        setRefundDetails({refid: refid, pcorderno: orderno, selectedOrderData: data});
        setPage("track");
    }

    const handleCancel = async() => {
        setFormValues((...prev) => ({
            ...prev,
            'agentid': agent.id,
            'agentName': agent.firstName + " " + agent.lastName,
            'clerkname': agent.firstName + " " + agent.lastName,
            'agentCountry': agent.countryid,
            transferType: 'cancel'
        }));
        const options = [];
        for (let reason of riaCancelReasons) {
            options.push({key: reason.id, value: reason.id, label: reason.value, name: reason.value});
        }
        setCancelReasons(options);
        
        setPage('cancelform');
    }

    const confirmCancel = async(pin) => {
        // if(agent?.parentuserid) {
        //     console.log("Parent Exist");
        // } else {
        //     console.log("Parent Does not Exist");
        // }
        setShowPin(false);
        const requestData = {
            authUser: agent.id,
            userid: selectedUserID,
            parentuserid: agent?.parentuserid ? agent?.parentuserid : agent.id,
            ...cancelFormValues,
            ...refundDetails,
            PIN: pin
        };
        const response = await riaCancelTransaction(requestData);

        if (response.Status !== '1') {
            let riaError = response?.payload?.response;
            let riaErrorMessage = '';
            if (riaError) {
                riaError = riaError.replaceAll(/&(amp;)*quot;/g, '"');
                riaError = JSON.parse(riaError);
                riaErrorMessage = riaError.message;
            }

            setAlertData(response, true, riaErrorMessage.length ? riaErrorMessage : null, true);
            return;
        }
        setAlertData(response, false, 'Transaction successfully cancelled.');
        setPage('landing');
    }

    const setAlertData = (response, isError, message, goToLanding) => {
        if (isError) {
            if (!message.length) {
                message = getErrorMessage2(response, isAutoRetry = true);
            }
            
            if (goToLanding) {
                setPage('landing');
            }
        }
        setAlert({
                showAlert: true,
                severity: isError ? "error" : "success",
                message: message,
                header: isError ? "Error" : "success"
            });
    }

    const getDeliveryMethods = async(country) => {

        const response = await riaGetDeliveryMethods(country);

        let deliveryMethods = response.payload.deliveryMethods;
        if (!Array.isArray(deliveryMethods)) {
            deliveryMethods = [deliveryMethods];
        }
        const allowedIds = [1, 2, 3, 34];

        const mappedDeliveryMethods = deliveryMethods
          .filter(({ id }) => allowedIds.includes(Number(id))) // Ensure `id` is a number
          .map(({ id, name }) => ({ key: id, value: id, label: name }));
        setRiaOptions((prev) => ({
            ...prev,
            deliveryMethods: mappedDeliveryMethods
        }));
    }

    const getOrderRequirements = async() => {
        const getTransferReasons = await riaIntegrationGetTransferReasons(formValues);
        if(getTransferReasons?.Status == "1") {
            let idTypes = getTransferReasons.payload.body.Response.Enum;
            console.log("getOrderRequirements_tfReasonsArr==========",idTypes);

            if (!Array.isArray(idTypes)) {
                idTypes = [idTypes];
            }
            const mappedTypes = idTypes.map(type => ({
                key: type.Value,
                label: type.Name,
                value: type.Value
            }));
            setRiaOptions((prev) => ({
                ...prev,
                transferReasons: mappedTypes
            }));
        }

        const response = await getRiaOrderRequirements(formValues);

        if (response.Status !== "1" || response?.payload?.Errors) {
            setAlertData(response, true, "", true);
            return;
        }

        let responseReqFields = response.payload.Response.RequiredFields.RequiredField;
        setRequiredFields(prev => {
            const updatedFields = { ...prev };
    
            responseReqFields.forEach(field => {
                if (updatedFields.hasOwnProperty(field.FieldName)) {
                    updatedFields[field.FieldName] = {
                        required: true,
                        minLength: field.MinLength || 0,
                        maxLength: field.MaxLength || 255, // Default max length
                    };
                }
            });
            if (updatedFields.BeneIDType.required) {
                getIDTypes();
            }
            return updatedFields;
        });
        setPage('recipient');
    }

    const getMobileWallets = async() => {
        const response = await riaGetMobileWallets(formValues);

        if (response.Status !== "1") {
            return;
        }

        let mobileWallets = response.payload.payoutPartnerLocations;
        if (!Array.isArray(mobileWallets)) {
            mobileWallets = [mobileWallets];
        }

        const mappedPartners = mobileWallets.map((wallet) => {
            let product111 = wallet.products;
            if (!Array.isArray(product111)) {
                product111 = [product111];
            }
            product111 = product111.find(product => product.id === "111");
            let productCurrencies = product111?.currencies || [];
            if (!Array.isArray(productCurrencies)) {
                productCurrencies = [productCurrencies];
            }
            const currencies = productCurrencies.map(currency => ({
                key: currency.code,
                label: currency.code,
                value: currency.code
            }));
            return {
                key: wallet.id,
                value: wallet.id,
                label: wallet.name,
                currencies
            };
        });
        setRiaOptions((prev) => ({
            ...prev,
            payoutPartners: mappedPartners
        }));
    }

    const getIDTypes = async() => {
        const response = await getRiaIDTypes(formValues);
        if (response.Status !== "1") {
            return;
        }
        let idTypes = response.payload.body.Response.Enum;
        if (!Array.isArray(idTypes)) {
            idTypes = [idTypes];
        }
        const mappedTypes = idTypes.map(type => ({
            key: type.Value,
            label: type.Name,
            value: type.Value
        }));
        setRiaOptions((prev) => ({
            ...prev,
            idTypes: mappedTypes
        }));
    }

    const getBanks = async() => {
        const response = await getRiaBanks(formValues);
        if (response.Status !== "1") {
            return;
        }
        let banks = response.payload;
        if (!Array.isArray(banks)) {
            banks = [banks];
        }

        const mappedBanks = banks.map((bankDetails) => {
            let bank = bankDetails.Riabanks.otherdetails;
            bank = bank.replaceAll(/&(amp;)*quot;/g, '"');
            bank = JSON.parse(bank);
            let bankCurrencies = bank.currencies;
            if (!Array.isArray(bankCurrencies)) {
                bankCurrencies = [bankCurrencies];
              }
            const currencies = bankCurrencies.map(currency => ({
                key: currency.code,
                label: currency.code,
                value: currency.code
            }));
            return {
                key: bank.id,
                value: bank.id,
                label: bank.name,
                currencies,
            };
        });

        setRiaOptions((prev) => ({
            ...prev,
            banks: mappedBanks
        }));
    }



    const requiredMappingExtra = {
        BeneEmail: 'receiverEmail',
        BeneAddress: 'receiverAddress',
        BeneZipCode: 'receiverZip',
        BeneIDType: 'beneidtype',
        BeneIDNo: 'beneidno',
        BeneCity: 'city',
        BenePhoneNo: 'receiverPhone',
        UnitaryBankAccountNo: 'unitarybankaccountno',
        BankAccountNo: 'receiverbankacct',
        BankBranchName: 'bankbranchname',
        BankRoutingCode: 'receiverbankroutingcode',
        BankBranchCity: 'receiverbankcity',
        BankBranchNo: 'receiverbanknumber',
        MobileWalletAccountNo: 'receivermobilewalletnumber'
    }

    const requiredMapping = [
        'rfirstname',
        'rlastname',
        'receivercountrydropdown',
        'receiverState',
        'transferreason'
    ]

    const validateFinalForm = (page) => {
        let errors = {};
    
        Object.keys(requiredMappingExtra).forEach(field => {
            const fieldData = requiredFields[field];
            if (fieldData.maxLength === "0") {
                fieldData.maxLength = 255;
            }
    
            if (fieldData.required && !formValues[requiredMappingExtra[field]]) {
                errors[field] = true;
            } else if (fieldData.minLength && formValues[requiredMappingExtra[field]]?.length < fieldData.minLength) {
                errors[field] = true;
            } else if (fieldData.maxLength && formValues[requiredMappingExtra[field]]?.length > fieldData.maxLength) {
                errors[field] = true;
            }
        });

        for (let item of requiredMapping) {
            if (!formValues[item]) {
                errors[item] = true;
            }
        }
    
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            return;
        }
        setPage(page);
        return Object.keys(errors).length === 0;
    };

    const validateCancelPage = () => {
        // if (!formValues.cancelreasoncode) {
        if (!cancelFormValues.cancelreasoncode) {
            setFormErrors({ cancelreasoncode: true });
            setAlertData(null, true, "Please select the reason for cancellation.", false);
            return;
        }
        setShowPin(true);
    }

    console.log("RIA_opts================",riaOptions.transferReasons);

    return (
        <Box className="container">
            <Box className="pageContainer" sx={{ width: "100%", margin: 'auto' }}>
                <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }} className="text-center">International Transfer - RIA</Typography>
                {page === 'landing' ?

                    <Box>
                        <Box className="contactContainer">
                            <Box className="d-flex justify-content-between">
                                <Box className="lh-lg fw-bold">Contacts</Box>
                            </Box>
                            <Contacts
                                contacts={contacts}
                                service={"RIA"}
                                setSelectedContact={setSelectedContact} />
                        </Box>
                        <Box className="historyContainer mt-3">
                            <Box className="fw-bold">Recent History</Box>
                            <InternationalTransferHistory
                                history={history}
                                service={"RIA"}
                                trackTransaction={(refNumber, data) => trackTransaction(refNumber, data)}
                                handleResend={(item) => resendTransaction(item)}
                            />
                        </Box>
                        <InternationalTransferFooterButtons
                            handleButtonOne={handleBack}
                            handleButtonTwo={() => setPage('receive')}
                            handleMiddleButton={() => setPage('send')}
                            buttonOneText="Return"
                            buttonTwoText="Receive Money"
                            middleButtonText="Send Money To New Contact"
                            showMiddleButton={true}
                        />

                    </Box> : ''}
                {page === 'send' ?
                    <Box
                        sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                        <RegistrationInput
                            label="Amount"
                            required={true}
                            onChange={(e) => editFormValues('ramount', e.target.value)}
                            value={formValues.ramount}
                            hasError={formErrors.ramount} />
                        <RegistrationSelect
                            label="Receiving Country"
                            type="text"
                            options={riaOptions.countries}
                            onChange={(e) => {editFormValues('receivecountry', e.target.value); getDeliveryMethods(e.target.value);}}
                            value={formValues.receivecountry}
                            required={true}
                            hasError={formErrors.receivecountry} />
                        <RegistrationSelect
                            label="Delivery Method"
                            options={riaOptions.deliveryMethods ?? []}
                            required={true}
                            onChange={(e) => editFormValues('deliverymethodid', e.target.value)}
                            value={formValues.deliverymethodid}
                            hasError={formErrors.deliverymethodid} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => validateForm('deliveryMethod')}
                            buttonOneText="Back"
                            buttonTwoText="Continue"
                        />
                    </Box>
                    : ''}
                {page === 'cashpickup' ?
                    <Box
                        sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                        <RegistrationSelect
                            label="Payout Partners"
                            options={riaOptions.payoutPartners ?? []}
                            required={true}
                            onChange={(e) => {editFormValues('payoutpartnerid', e.target.value); handlePartnerChange(e.target.value)}}
                            value={formValues.payoutpartnerid}
                            hasError={formErrors.payoutpartnerid} />
                        {requiredFields.payoutpartnerlocation &&
                            <RegistrationSelect
                                label="Pickup location"
                                options={riaOptions.payoutPartnersLocations ?? []}
                                required={true}
                                onChange={(e) => editFormValues('payoutpartnerlocation', e.target.value)}
                                value={formValues.payoutpartnerlocation}
                                hasError={formErrors.payoutpartnerlocation} />
                        }
                        <RegistrationSelect
                            label="Currency"
                            options={selectedCurrencies ?? []}
                            required={true}
                            onChange={(e) => editFormValues('currencyCode', e.target.value)}
                            value={formValues.currencyCode}
                            hasError={formErrors.currencyCode} />

                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('send')}
                            handleButtonTwo={() => validateForm('getRequirements')}
                            buttonOneText="Back"
                            buttonTwoText="Continue"
                        />
                    </Box>
                    : ''}
                {page === 'bank' ?
                    <Box
                        sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                        <RegistrationSelect
                            label="Reciever's Bank"
                            required={true}
                            options={riaOptions.banks ?? []}
                            onChange={(e) => {editFormValues('receiverbankid', e.target.value); handleBankChange(e.target.value); editFormValues('payoutpartnerid', e.target.value);}}
                            value={formValues.receiverbankid} />
                        <RegistrationSelect
                            label="Currency"
                            options={selectedCurrencies ?? []}
                            required={true}
                            onChange={(e) => editFormValues('currencyCode', e.target.value)}
                            value={formValues.currencyCode}
                            hasError={formErrors.currencyCode} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('deliveryMethod')}
                            handleButtonTwo={() => validateForm('getRequirements')}
                            buttonOneText="Back"
                            buttonTwoText="Continue"
                        />
                    </Box>
                    : ''}
                {page === 'recipient' ?
                    <Box
                        sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                        {requiredFields.MobileWalletAccountNo?.required && <RegistrationInput
                            label="Receiver Mobile Account Number"
                            required={true}
                            onChange={(e) => editFormValues('receivermobilewalletnumber', e.target.value)}
                            value={formValues.receivermobilewalletnumber}
                            hasError={formErrors.MobileWalletAccountNo} />}
                        <RegistrationInput
                            label="Receiver First Name"
                            required={true}
                            onChange={(e) => editFormValues('rfirstname', e.target.value)}
                            value={formValues.rfirstname}
                            hasError={formErrors.rfirstname} />
                        <RegistrationInput
                            label="Receiver Middle Name"
                            required={false}
                            onChange={(e) => editFormValues('rmiddlename', e.target.value)}
                            value={formValues.rmiddlename}
                            hasError={formErrors.rmiddlename} />
                        <RegistrationInput
                            label="Receiver Last Name"
                            required={true}
                            onChange={(e) => editFormValues('rlastname', e.target.value)}
                            value={formValues.rlastname}
                            hasError={formErrors.rlastname} />
                        <RegistrationInput
                            label="Receiver Second Last Name"
                            required={false}
                            onChange={(e) => editFormValues('rlastname2', e.target.value)}
                            value={formValues.rlastname2}
                            hasError={formErrors.rlastname2} />
                        <RegistrationSelect
                            label="Receiver's Nationality"
                            options={riaOptions.countries ?? []}
                            required={true}
                            onChange={(e) => editFormValues('receivercountrydropdown', e.target.value)}
                            value={formValues.receivercountrydropdown}
                            hasError={formErrors.receivercountrydropdown} />
                        <RegistrationSelect
                            label="Receiver's State of Nationality"
                            options={riaOptions.states ?? []}
                            required={true}
                            onChange={(e) => editFormValues('receiverState', e.target.value)}
                            value={formValues.receiverState}
                            hasError={formErrors.receiverState} />
                        {requiredFields.BeneCity?.required &&
                            <RegistrationInput
                                label="Receiver's City"
                                required={true}
                                onChange={(e) => editFormValues('city', e.target.value)}
                                value={formValues.city}
                                hasError={formErrors.BeneCity} />
                        }
                        {requiredFields.BeneAddress?.required &&
                            <RegistrationInput
                                label="Receiver's Address"
                                required={true}
                                onChange={(e) => editFormValues('receiverAddress', e.target.value)}
                                value={formValues.receiverAddress}
                                hasError={formErrors.BeneAddress} />
                        }
                        {requiredFields.BeneEmail?.required &&
                            <RegistrationInput
                                label="Receiver's Email"
                                required={true}
                                onChange={(e) => editFormValues('receiverEmail', e.target.value)}
                                value={formValues.receiverEmail}
                                hasError={formErrors.BeneEmail} />
                        }
                        {requiredFields.BenePhoneNo?.required &&
                            <RegistrationInput
                                label="Receiver's Phone"
                                required={true}
                                onChange={(e) => editFormValues('receiverPhone', e.target.value)}
                                value={formValues.receiverPhone}
                                hasError={formErrors.BenePhoneNo} />
                        }
                        {requiredFields.BeneZipCode?.required &&
                            <RegistrationInput
                                label="Receiver's ZipCode / Postal Code"
                                required={true}
                                onChange={(e) => editFormValues('receiverZip', e.target.value)}
                                value={formValues.receiverZip}
                                hasError={formErrors.BeneZipCode} />
                        }
                        {requiredFields.UnitaryBankAccountNo?.required &&
                            <RegistrationInput
                                label="Receiver's Bank Account Number"
                                required={true}
                                onChange={(e) => editFormValues('unitarybankaccountno', e.target.value)}
                                value={formValues.unitarybankaccountno}
                                hasError={formErrors.UnitaryBankAccountNo} />
                        }
                        {requiredFields.BankAccountNo?.required &&
                            <RegistrationInput
                                label="Receiver's Bank Account Number"
                                required={true}
                                onChange={(e) => editFormValues('receiverbankacct', e.target.value)}
                                value={formValues.receiverbankacct}
                                hasError={formErrors.BankAccountNo} />
                        }
                        {requiredFields.BankBranchName?.required &&
                            <RegistrationInput
                                label="Receiver's Bank Branch Name"
                                required={true}
                                onChange={(e) => editFormValues('bankbranchname', e.target.value)}
                                value={formValues.bankbranchname}
                                hasError={formErrors.BankBranchName} />
                        }
                        {requiredFields.BankBranchNo?.required &&
                            <RegistrationInput
                                label="Receiver's Bank Branch Number"
                                required={true}
                                onChange={(e) => editFormValues('receiverbanknumber', e.target.value)}
                                value={formValues.receiverbanknumber}
                                hasError={formErrors.BankBranchNo} />
                        }
                        {requiredFields.BankRoutingCode?.required &&
                            <RegistrationInput
                                label="Receiver's Bank Routing Code"
                                required={true}
                                onChange={(e) => editFormValues('receiverbankroutingcode', e.target.value)}
                                value={formValues.receiverbankroutingcode}
                                hasError={formErrors.BankRoutingCode} />
                        }
                        {requiredFields.BankBranchCity?.required &&
                            <RegistrationInput
                                label="Receiver's Bank City"
                                required={true}
                                onChange={(e) => editFormValues('receiverbankcity', e.target.value)}
                                value={formValues.receiverbankroutingcode}
                                hasError={formErrors.BankBranchCity} />
                        }
                        {requiredFields.BeneIDType?.required &&
                            <RegistrationSelect
                                label="Receiver's ID Type"
                                options={riaOptions.idTypes ?? []}
                                required={true}
                                onChange={(e) => editFormValues('beneidtype', e.target.value)}
                                value={formValues.beneidtype}
                                hasError={formErrors.BeneIDType} />
                        }
                        {requiredFields.BeneIDNo?.required &&
                            <RegistrationInput
                                label="Receiver's ID Number"
                                required={true}
                                onChange={(e) => editFormValues('beneidno', e.target.value)}
                                value={formValues.beneidno}
                                hasError={formErrors.BeneIDNo} />
                        }
                        <RegistrationSelect
                            label="Transfer Reason"
                            required={true}
                            options={riaOptions.transferReasons ?? []}
                            onChange={(e) => {
                                console.log("RegistrationSelect============",e);
                                    editFormValues('transferreason', e.target.label);
                                    editFormValues('transferreasonid', e.target.value);
                                }
                            }
                            value={formValues.transferreason}
                            hasError={formErrors.transferreason} />
                            
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => validateFinalForm('getTransaction')}
                            buttonOneText="Back"
                            buttonTwoText="Continue"
                        />
                    </Box> : ''}
                {page === 'mobile' ?
                    <Box
                        sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                        <RegistrationSelect
                            label="Select Payout Location"
                            options={riaOptions.payoutPartners ?? []}
                            required={true}
                            onChange={(e) => {editFormValues('virtualPaymentProviderID', e.target.value); handlePartnerChange(e.target.value)}}
                            value={formValues.virtualPaymentProviderID} />
                        <RegistrationSelect
                            label="Currency"
                            options={selectedCurrencies ?? []}
                            required={true}
                            onChange={(e) => editFormValues('currencyCode', e.target.value)}
                            value={formValues.currencyCode}
                            hasError={formErrors.currencyCode} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => setPage('getRequirements')}
                            buttonOneText="Return"
                            buttonTwoText="Continue"
                        />
                    </Box> : ''}
                {page === 'summary' ?
                    <InternationalTransferSummary
                        transferDetails={formValues}
                        type="send"
                        handleReturn={() => setPage('reload')}
                        service="RIA"
                        user={selectedUser}
                        handleContinue={() => setPage("sendTransaction")}
                        handleSaveContact={saveContact}
                        contactButtonText={contactButtonText}
                    />
                    : ''}

                {page === 'receivesummary' &&
                    <InternationalTransferSummary
                        transferDetails={formValues}
                        type="receive"
                        handleReturn={() => setPage('reload')}
                        service="RIA"
                        user={selectedUser}
                        handleContinue={() => setPage("receiveTransaction")}
                    />
                }
                {page === 'shortform' ?

                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        <RegistrationInput
                            label="Amount"
                            type="number"
                            onChange={(e) => editFormValues('ramount', e.target.value)}
                            value={formValues.ramount}
                            hasError={formErrors.ramount} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => validateForm('getTransaction')}
                            buttonOneText="Return"
                            buttonTwoText="Continue"
                        />
                    </Box>
                    : ''
                }
                {page === 'receive' ?

                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        <RegistrationInput
                            label="RIA PIN"
                            type="number"
                            onChange={(e) => editFormValues('riapin', e.target.value)}
                            value={formValues.riapin} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => validateForm('getReceiveTransaction')}
                            buttonOneText="Return"
                            buttonTwoText="Continue"
                        />
                    </Box>
                    : ''
                }
                {page === 'receipt' &&
                    <InternationalTransferSummary
                        type="send"
                        transferDetails={formValues}
                        handleReturn={() => setPage("reload")}
                        user={selectedUser}
                        handleContinue={() => setPage("reload")}
                        isReceipt={true}
                        service={"RIA"}
                    />
                }
                {
                    page === 'receiptreceive' &&
                    <InternationalTransferSummary
                        type="receive"
                        transferDetails={formValues}
                        handleReturn={() => setPage("reload")}
                        user={selectedUser}
                        handleContinue={() => setPage("reload")}
                        isReceipt={true}
                        service={"RIA"}
                    />
                }
                {page === 'contact' ?
                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        {getContactInformation()}

                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => sendToContact()}
                            buttonOneText="Cancel"
                            buttonTwoText="Send To This Contact"
                        />
                    </Box>
                    : ''
                }
                {
                    page === 'wait' ?
                        <Box sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                            <Box
                                className="mt-5 d-flex justify-content-center align-items-center">
                                <CircularProgress
                                    size="10rem" />
                            </Box>
                        </Box>
                        : ''
                }
                {
                    page === 'track' &&
                    <InternationalTransferTrack 
                        transactionStatus={orderStatus}
                        handleReturn={() => setPage('reload')}
                        isCancellable={true}
                        handleCancel={handleCancel}
                    />
                }

                {page === 'cancelform' ?

                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        <RegistrationSelect
                            label="Reason"
                            options={cancelReasons ?? []}
                            required={true}
                            onChange={(e) => setCancelFormValues({ cancelreasoncode: e.target.value, cancelcomments: e.target.label })}
                            value={cancelFormValues.cancelreasoncode}
                            hasError={formErrors.cancelreasoncode} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={validateCancelPage}
                            buttonOneText="Return"
                            buttonTwoText="Cancel Transaction"
                        />
                    </Box>
                    : ''
                }
                <PinPad show={showPin} handleConfirm={handlePinConfirm} onClick={() => setShowPin(false)} />
            </Box>
            <CustomAlert severity={alert.severity} show={alert.showAlert} header={alert.header} message={alert.message} onClick={(prev) => setAlert({ ...prev, showAlert: false })} autoclose={alert.severity === "error" ? false : true} />
        </Box>
    );
}

export default RIA;
